var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoData({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 74,
    viewBox: "0 0 87 74",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 73.4737V21.9939C14.0081 14.6395 40.6235 18.8421 43.7753 21.9939C55.8223 17.2312 77.278 20.0094 86.5 21.9939V73.4737C63.3866 67.17 46.9271 72.0729 43.0749 73.4737C22.9032 67.8704 5.95344 71.139 0 73.4737Z",
    fill: "#414141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 69.271V17.7913C14.0081 10.4368 40.6235 14.6394 43.7753 17.7913C55.8223 13.0285 77.278 15.8068 86.5 17.7913V69.271C63.3866 62.9674 46.9271 67.8702 43.0749 69.271C22.9032 63.6678 5.95344 66.9363 0 69.271Z",
    fill: "#747474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60303 6.05896C22.6929 5.21848 37.9384 13.6467 43.4249 17.9658V69.4453C29.697 59.3594 12.4903 56.838 5.60303 56.838V6.05896Z",
    fill: "#B2B2B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.099 4.2492L78.4451 0.396973L60.5848 30.8646L59.5342 41.7209L67.5888 35.067L85.099 4.2492Z",
    fill: "url(#paint0_linear_15_11327)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_11327",
    x1: 72.1415,
    y1: 18.9577,
    x2: 59.5342,
    y2: 40.6703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#EAC100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#967C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.edbd38961f972cc46dad455abed6772a.svg";
export { ForwardRef as ReactComponent };